let wxConfig = {
  //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  appId: 'wx99ead17d9d250ad4', // 必填，公众号的唯一标识
  // appId: 'wx6f69107f621467c6',
  // appId: 'wx2b3cd648d65851df',
  // appId: 'wx7c54072facd364f7',
  // appId: 'wx5ee04d8b4b256379',

  jsApiList: ['getLocation', 'chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
}

let userWxService = {
  config: wxConfig
}

userWxService.getAuthUrl = function (redirectUri, scope, state) {
  console.log(redirectUri, scope, state);

  let authUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + wxConfig.appId + '&redirect_uri=' + encodeURIComponent(redirectUri)
  authUrl += '&response_type=code&scope=' + scope + '&state=' + state + '#wechat_redirect'
  return authUrl
}
userWxService.isWxAgent = function () {
  let userAgent = window.navigator.userAgent.toLowerCase()
  if (userAgent.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  }
  return false
}

export default userWxService



// WEBPACK FOOTER //
// ./src/service/wx-service.js